<script setup>
import { ref } from "vue";
import { Vue3SlideUpDown } from "vue3-slide-up-down";
import { dateHelper } from "@shop/frontend/web/js/helpers/dateHelper";
import useCartStore from "@vueApp/store/modules/cart";
import ITicket from "../ITicket/ITicket.vue";
import ITeams from "../ITeams/ITeams.vue";

const cartStore = useCartStore();
const props = defineProps({
  itemCase: {
    type: Object,
    required: true,
  },
  trashButton: {
    type: Boolean,
    default: true,
  },
});

const isEventsListOpen = ref(true);

function removeEventFromSubscription(subscriptionEventObject) {
  cartStore.removeEventFromSubscription(subscriptionEventObject, props.itemCase.orderId);
}

function removeOrder(orderId) {
  cartStore.removeOrderById(orderId);
}

function changeLoyalty(ticket, eventId, categoryId, priceId) {
  cartStore.changeLoyalty(ticket, eventId, props.itemCase.orderId, categoryId, priceId);
}

</script>

<template>
  <div class="i-order-subscribe-item__sub-wrapper">
    <button
      v-if="trashButton"
      class="i-order-subscribe-item__delete"
      @click="removeOrder(itemCase.orderId)"
    >
      <p>Удалить</p>
      <svg width="20" height="20">
        <use xlink:href="#basket" />
      </svg>
    </button>
  </div>
  <vue3-slide-up-down v-model="isEventsListOpen" class="slider">
    <div v-for="(item, index) in itemCase.events" :key="index" class="i-order-subscribe-item__sub">
      
        <ITeams
          v-if="item.teams"
          :first-team="{
            ...item.teams[0],
            imageUrl: item.images.home_team,
          }"
          :second-team="{
            ...item.teams[1],
            imageUrl: item.images.guest_team,
          }"
          :is-history="true"
          :is-sub="true"
        />
        <div v-else class="i-order-subscribe-item__sub-name">
          <div class="i-order-subscribe-item__sub-title">
            {{ item.name }}
          </div>
        </div>
        <div class="i-order-subscribe-item__price">
          <span>
            Цена
          </span>
           <strong>
            {{ item.summ }} ₽
          </strong>
        </div>
      <div class="i-order-subscribe-item__details">
        <span class="time">
          <svg>
            <use xlink:href="#calendar" />
          </svg>
          {{ dateHelper.getFormattedDate(item.date, "DD.MM.YYYY dd HH:mm") }}
        </span>
        <span class="place">
          <svg>
            <use xlink:href="#local" />
          </svg>
          {{ item.place }}
        </span>
      </div>
      <div class="i-order-subscribe-item__tickets">
        <div v-for="ticket in item.carts" :key="ticket.place" class="tickets-item">
          <i-ticket
            :ticket="ticket"
            :inactive="true"
            :short="true"
            @change-loyalty="
              ({ ticket, categoryId, priceId }) =>
                changeLoyalty(ticket, itemCase.id, categoryId, priceId)
            "
          />
        </div>
      </div>
      <div class="i-order-subscribe-item__price">
        Цена: <strong>{{ item.summ }} ₽</strong>
      </div>
    </div>
  </vue3-slide-up-down>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-order-subscribe-item.scss";
</style>
